import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2 } from 'lucide-react';
export function Transition() {
  return <section className="bg-brand-beige py-20 px-6" data-id="element-883">
      <div className="max-w-3xl mx-auto text-center" data-id="element-884">
        <FadeIn data-id="element-885">
          {/* Título principal */}
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-brand-green mb-6 leading-tight" data-id="element-886">
            NO TODOS COMIENZAN CON AMAZON FBA…
            <br data-id="element-887" />
            <span className="text-brand-green/80" data-id="element-888">Y ESO ESTÁ BIEN.</span>
          </h2>

          {/* Texto secundario */}
          <p className="text-lg md:text-xl text-brand-text/70 mb-10 leading-relaxed" data-id="element-889">
            Existe una forma MÁS SIMPLE de comenzar a vender en Amazon, con
            menor inversión y mayor control desde el primer día.
          </p>

          {/* Título destacado */}
          <div className="bg-white border border-brand-green/10 rounded-2xl px-6 py-8 md:px-10 md:py-10 mb-10 shadow-sm" data-id="element-890">
            <p className="text-xs font-semibold uppercase tracking-widest text-brand-gold mb-3" data-id="element-891">
              ⚡ La alternativa práctica
            </p>
            <h3 className="text-2xl md:text-3xl font-bold text-brand-green mb-6" data-id="element-892">
              APRENDE A VENDER CON AMAZON FBM
            </h3>

            {/* Texto persuasivo */}
            <p className="text-base md:text-lg text-brand-text/80 mb-4 leading-relaxed" data-id="element-893">
              Con Amazon FBM puedes comenzar desde casa sin necesidad de enviar
              inventario a bodegas FBA.
            </p>
            <p className="text-base md:text-lg text-brand-text/80 mb-4 leading-relaxed" data-id="element-894">
              Tendrás el control de tus productos, tus envíos y tus ventas
              mientras aprendes paso a paso cómo funciona realmente Amazon.
            </p>
            <p className="text-base md:text-lg text-brand-text/70 leading-relaxed italic" data-id="element-895">
              Ideal para personas que quieren empezar con una inversión más
              baja, menos complicaciones y una forma más práctica de generar
              ingresos online.
            </p>
          </div>

          {/* Texto de refuerzo - bullets */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-2xl mx-auto mb-10 text-left" data-id="element-896">
            <div className="flex items-start gap-3 bg-white/60 rounded-xl px-4 py-3" data-id="element-897">
              <CheckCircle2 className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-898" />
              <span className="text-base font-medium text-brand-text/80" data-id="element-899">
                Menor inversión inicial
              </span>
            </div>
            <div className="flex items-start gap-3 bg-white/60 rounded-xl px-4 py-3" data-id="element-900">
              <CheckCircle2 className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-901" />
              <span className="text-base font-medium text-brand-text/80" data-id="element-902">
                Más control sobre tus productos
              </span>
            </div>
            <div className="flex items-start gap-3 bg-white/60 rounded-xl px-4 py-3" data-id="element-903">
              <CheckCircle2 className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-904" />
              <span className="text-base font-medium text-brand-text/80" data-id="element-905">
                Aprende desde cero paso a paso
              </span>
            </div>
            <div className="flex items-start gap-3 bg-white/60 rounded-xl px-4 py-3" data-id="element-906">
              <CheckCircle2 className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-907" />
              <span className="text-base font-medium text-brand-text/80" data-id="element-908">
                Empieza desde casa incluso si eres principiante
              </span>
            </div>
          </div>

          {/* Frase final */}
          <p className="text-xl md:text-2xl font-serif text-brand-green font-semibold leading-relaxed" data-id="element-909">
            Amazon FBM puede ser el primer paso que necesitabas para comenzar tu
            negocio online.
          </p>
        </FadeIn>
      </div>
    </section>;
}